var comparison = document.getElementById("comparison");

if (comparison) {
	var partners = comparison.getElementsByClassName("partners");
    var height = partners[0].offsetHeight;
    
    window.addEventListener('load', function() {
        for (var i = 0; i < partners.length; i++) {
            var comparedHeight = partners[i].offsetHeight;
        
            if (comparedHeight > height) {
                height = comparedHeight;
            }
        }
        
        for (var i = 0; i < partners.length; i++) {
            partners[i].style.height = height + "px";
        }
    });
}

jQuery(document).foundation();

jQuery(document).on('closed.zf.reveal', '[data-reveal]', function() {
	var iframe = (jQuery)(this).find('iframe');
	if (iframe) {
		iframe.attr('src', iframe.attr('src'));
	}
});

jQuery('[data-open="how-it-goes"]').on('click', function() {
	var video = 'https://api.vadoo.tv/iframe_test?id=' + (jQuery)(this).data('video');
	jQuery('#how-it-goes').find('iframe').attr('src',video);
});

jQuery('.tooltip-wrap').on('click', function() {
	(jQuery)('.tooltip').hide();
	(jQuery)(this).find('.tooltip').show();
});

jQuery(document).ready(function() {
	var opts = {
		angle: 0, // The span of the gauge arc
		lineWidth: 0.12, // The line thickness
		radiusScale: 1, // Relative radius
		pointer: {
		  length: 0.32, // // Relative to gauge radius
		  strokeWidth: 0.06, // The thickness
		  color: '#383838' // Fill color
		},
		limitMax: true,     // If false, max value increases automatically if value > maxValue
		limitMin: false,     // If true, the min value of the gauge will be fixed
		generateGradient: true,
		highDpiSupport: true,     // High resolution support
		staticZones: [
			{strokeStyle: "#cc4b37", min: 0, max: 30}, // Red
			{strokeStyle: "#ef981c", min: 30, max: 100}, // Yellow
			{strokeStyle: "#3adb76", min: 100, max: 300}, // Green
		],
	};

	jQuery('.gauge').each(function() {
		var target = this;
		
		if (target) {
			var gaugeVal = target.dataset.download;
			var gaugeVal2 = target.dataset.upload;
			var gaugeValText = '';
			
			if (gaugeVal > 0) { gaugeValText = gaugeVal } else { gaugeValText = '???' }
			if (gaugeVal2 > 0) { gaugeVal2Text = gaugeVal2 } else { gaugeVal2Text = '???' }
			
			var speedchartText1 = '<div class="text-larger"><b>' + gaugeValText + '</b> Mbs/s</div>';
			var speedchartText2 = '<div class="text-small text-gray">Upload ' + gaugeVal2Text + ' Mbs/s</div>';
			
			jQuery(this).parent().append('<div class="speedchart-text">' + speedchartText1 + speedchartText2 + '</div>');
		}
		
		var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
		gauge.maxValue = 300; // set max gauge value
		gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
		gauge.animationSpeed = 32; // set animation speed (32 is default value)
		gauge.set(gaugeVal);
	});

	var guide = document.querySelector('.guide');

	if (guide) {
		var step = 0;
		var result = 0;
		var result2 = 0;
		
		jQuery('.guide-nav a').addClass('disabled');
		
		jQuery('.repeat-guide').on('click', function() {
			step = 1;
			result = 0;
			result2 = 0;
			
			jQuery('.guide-final-result').addClass('hide');
			jQuery('.guide-final-result').find('.speedchart-text').remove();
			jQuery('.guide-nav a').addClass('disabled');
			jQuery('.guide').find('[data-step]').addClass("hide");
			jQuery('.guide').find('[data-step="1"]').removeClass("hide");
			jQuery('.guide').find('.step').text(step);
			jQuery('.guide').find('.guide-result > b').text('???');
			jQuery('.guide').removeClass("hide");
		});
		
		jQuery(this).find('.guide-answers a').on('click', function() {
			step = jQuery(this).parents('.guide-question').data("step");
			jQuery(this).parents('.guide').find('[data-step]').addClass("hide");
			
			var resultNew = jQuery(this).data('result');
			
			if (resultNew > result) {
				result = resultNew;
			}
			
			result2 = jQuery(this).data('resultupload');

			if (result > 0) {
				jQuery(this).parents('.guide').find('.guide-result > b').text(result);
			}
			
			var max = jQuery(this).parents('.guide').data('max');
			if (step == max) {
				jQuery(this).parents('.guide').addClass("hide");
				
				jQuery(this).parents('.guide').next('.guide-final-result').removeClass("hide");
				jQuery(this).parents('.guide').next('.guide-final-result').find('.gauge').attr('data-download', result);
				
				var target = document.querySelector('.guide-gauge');
				var gauge = new Gauge(target).setOptions(opts);
				gauge.maxValue = 300; // set max gauge value
				gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
				gauge.animationSpeed = 32; // set animation speed (32 is default value)
				gauge.set(result);
				
				var speedchartText1 = '<div class="text-larger"><b>' + result + '</b> Mbs/s</div>';
				var speedchartText2 = '';
				if (result2) { var speedchartText2 = '<div class="text-small text-gray">Upload ' + result2 + ' Mbs/s</div>'; }
			
				jQuery(this).parents('.guide').next('.guide-final-result').find('.speedchart').append('<div class="speedchart-text">' + speedchartText1 + speedchartText2 + '</div>');
				jQuery(this).parents('.guide').next('.guide-final-result').find('.button').attr('href', '?filter-download=' + result);
			} else {
				step = step + 1;
			
				jQuery(this).parents('.guide').find('[data-step="' + step + '"]').removeClass("hide");
				jQuery(this).parents('.guide').find('.step').text(step);
				jQuery(this).parents('.guide').find('.guide-nav a').removeClass('disabled');
			}
		});
		
		jQuery(this).find('.guide-nav a').on('click', function() {
			if (step > 1) {
				jQuery(this).parents('.guide').find('[data-step]').addClass("hide");
			
				step = step - 1;
				
				jQuery(this).parents('.guide').find('[data-step="' + step + '"]').removeClass("hide");
				jQuery(this).parents('.guide').find('.step').text(step);
				
				if (step > 1) {
					jQuery(this).parents('.guide').find('.guide-nav a').removeClass('disabled');
				} else {
					jQuery(this).parents('.guide').find('.guide-nav a').addClass('disabled');
				}
			}
		});
	}
	
	
	/* Vylepšení pro jednodušší vkládání obsahu */
	var heading1 = document.querySelector('#article > .wp-block-group__inner-container > h1');
	var headings = document.querySelectorAll('#content > .wp-block-group__inner-container > h2');
	var breadcrumb = document.querySelector('.breadcrumb');
	
	if (breadcrumb) {
		breadcrumb = breadcrumb.outerHTML;
	}

	if (heading1) {
		jQuery('.breadcrumb').remove();
		jQuery(heading1).next().andSelf().wrapAll('<div class="box"></div>');
		jQuery(heading1).parent().prepend(breadcrumb);
	}
	
	if (headings) {
		var sectionNumber = 0;
		var sectionNav;
		var sectionHeading;
		
		jQuery('#content > .wp-block-group__inner-container > h2').each(function( index ) {
			sectionNumber = index + 1;
			var section = 'section-' + sectionNumber;
			
			jQuery('<div class="section-separator"></div>').insertBefore(this);
			jQuery(this).next().andSelf().wrapAll('<div class="wp-block-group__inner-container"></div>');
			jQuery(this).parent().wrap('<div id="' + section + '" class="section section-invert wp-block-group"></div>');
			jQuery(this).before('<div class="supheader">' + sectionNumber + '. Kapitola</div>');
			
			sectionHeading = jQuery(this).html();
			sectionNav = '<a class="content-nav" href="#' + section + '" data-smooth-scroll><span class="content-number"><b>' + sectionNumber + '</b> kapitola</span><div class="content-nav-section">' + sectionHeading + '</div></a>';
			jQuery('#list-of-content').append(sectionNav);
		});

		jQuery('.section-separator').each(function( index ) {
			jQuery(this).prev('.wp-block-group').addClass('last-block-group');
		});

		jQuery('#list-of-content > a').on('click', function() {
			var target = jQuery(this).attr('href');
			console.log(target);
			
			Foundation.SmoothScroll.scrollToLoc(target, {
				threshold: 50,
				offset: 0
			}, function() {
			   console.log('scrolled');
			});
			
			return false;
		});
	}
	/* Konec vylepšení */

	/* Vytvoření scrollovacích puntíků pro pohyb mezi kapitolami */
	window.onscroll = function() { scrollFunction() };
	var windowHeight = jQuery(window).height();
	var pageHeight = jQuery('body').innerHeight() - 1000;
	var contentNavList = document.getElementById("list-of-content");
	var quickChoice = document.getElementById("quickChoice");

	/* Pozice, kdy se mají začít zobrazovat navigační puntíky */
	if (contentNavList) {
		var contentNavPos = contentNavList.offsetTop + 100;
		cloneContentNav();
	}
	
	function cloneContentNav() {
		var c = document.getElementById("list-of-content").children;
		
		var contentNav = document.createElement("div");
		var i;
		for (i = 0; i < c.length; i++) {
			var contentNavItem = c[i];
			
			var contentNavItemNumber = contentNavItem.getElementsByClassName("content-number")[0];
			contentNavItem.removeChild(contentNavItemNumber);
			
			contentNavItemNumber = contentNavItemNumber.outerHTML;
			
			var contentNavItemText = document.createElement("div");
			contentNavItemText.classList.add("content-nav-section");
			var contentNavItemTextContent = document.createTextNode(contentNavItem.text);
			contentNavItemText.appendChild(contentNavItemTextContent);
	
			contentNavItem.innerHTML = contentNavItemNumber;
			contentNavItem.appendChild(contentNavItemText);
			
			var clone = contentNavItem.cloneNode(true);
			contentNav.appendChild(clone);
		}
		
		contentNav.setAttribute("id", "content-nav");
		document.getElementById("footer").appendChild(contentNav);
	}
	/* Konec vytvoření puntíků */
	
	jQuery('#content-nav > a').on('click', function() {
		var target = jQuery(this).attr('href');

		Foundation.SmoothScroll.scrollToLoc(target, {
			threshold: 50,
			offset: 0
		}, function() {
		   console.log('scrolled');
		});
		
		return false;
	});
	
	function scrollFunction() {
		if ((jQuery(window).scrollTop() > 400) && (jQuery(window).scrollTop() < pageHeight)) {
			jQuery('#quickChoice').addClass('fixed');
			
			/* Tam, kde bude quickChoice, posunout scroll šipku výš */
			if (quickChoice) {
				jQuery('#scrollTop').addClass('above-quickChoice');
			}
		} else {
			jQuery('#quickChoice').removeClass('fixed');
			jQuery('#scrollTop').removeClass('above-quickChoice');
		}
		
		if (jQuery(window).scrollTop() > 3000) {
			jQuery('#scrollTop').addClass('fixed');
		} else {
			jQuery('#scrollTop').removeClass('fixed');
		}
		
		if (contentNavPos) {
			if (jQuery(window).scrollTop() > contentNavPos) {
				jQuery('#content-nav').addClass('fixed');
			} else {
				jQuery('#content-nav').removeClass('fixed');
			}
		}
	}
});

jQuery(document)
.on('keypress', function(event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    
    if (keycode == '13' || keycode == '27') {
      jQuery('.select').removeClass('opened');
    }
})
.on('click', function() {
    jQuery('.select').removeClass('opened');
})
.on('click', '.select', function(event) {
    jQuery(this).toggleClass('opened');
	event.stopPropagation();
})
.on('click', '.select > .options > span', function(event) {
    var filter = jQuery(this).data('filter');
	var filterName = jQuery(this).text();
	jQuery(this).parent().parent().find('input').val(filter);
	jQuery(this).parent().parent().find('.option > span').text(filterName);
	jQuery(this).parent().find('span').removeClass('active');
	jQuery(this).addClass('active');
})
.on('change', '.rangeslider-input', function(event) {
	var value = jQuery(this).val();
	jQuery(this).next().val(value).change();
})
.on('click', '.filter-compare', function(event) {
    Foundation.SmoothScroll.scrollToLoc('#offers', {
		threshold: 50,
		offset: 0
	}, function() {
	   console.log('scrolled');
	});
})
.on('click', '.offer-show-more-info', function(event) {
    var toggle = '#' + (jQuery)(this).data('target');
	(jQuery)(toggle).toggleClass('hide');
})
.on('click', '.box-links [data-show]', function(event) {
    var toggle = '#' + (jQuery)(this).data('show');
	(jQuery)(toggle).toggleClass('show');
	(jQuery)(this).hide();
	return false;
});